import React from "react";
import {SocketProvider} from "@unibuddy/sockets";

import {getSocketConnectionKey, usePostMessageContext} from "./PostMessageProvider";
import {getenv} from "../utils/getenv";
import {useUniversityContext} from "./UniversityProvider";

export function SocketWrapperProvider({children}: Readonly<{children: React.ReactNode}>) {
    const {chatVisible} = usePostMessageContext();
    const {universityId} = useUniversityContext();
    const hasConnected =
        window.sessionStorage.getItem(getSocketConnectionKey(universityId)) === "true";
    const isNotEmbedded = window.self === window.top;
    const useSocketProvider = isNotEmbedded || chatVisible || hasConnected;

    if (useSocketProvider) {
        return (
            <SocketProvider
                token="test-token"
                socketCredentials={{
                    PUSHER_APP_KEY: getenv("PUSHER_APP_KEY"),
                    PUSHER_APP_CLUSTER: getenv("PUSHER_APP_CLUSTER"),
                    PUSHER_AUTH_URL: getenv("PUSHER_AUTH_URL"),
                }}
            >
                {children}
            </SocketProvider>
        );
    }

    return children;
}
